const tasks = {
    activeTasks: [],
    completedTasks: null,
    all: null,
    active: false,
    groupId: "",
    selectedTasksFilter: {
        groupId: null,
        users: null,
        applications: null,
        processes: null,
        statuses: null
    },
    selectedAppName: ""
};

export default tasks;
